import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Typography } from "@mui/material";
import * as Yup from "yup";
import Upperarrow from "../../../../icons/Upperarrow";
import UploadUser from "./UploadUser";
import BaseURL from "../../../../utils/base-uri.json";
import axios from "../../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import VariableSizeSelect from "../../../../utils/VariableSizeSelect";
import AutoCompleteVariableSize from "../../../../utils/AutoCompleteVariableSize";
import { getOrgType } from "../../../../utils/Token";
import CloseIcon from '@mui/icons-material/Close';

const toastNotify = (message, isSuccess = true) => {
  if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 220,
    },
  },
};
export default function Adduser(props) {
  const navigate = useNavigate();

  const [orgTypes, setOrgTypes] = useState([
    { value: "-1", text: "Select Organization Type", selected: false },
  ]);
  const [organizations, setOrganizations] = useState([
    { value: "-2", text: "Select Organization", selected: false },
  ]);
  const [orgType, setOrgType] = useState(getOrgType() == "Vendor" ? 3 : -1);
  const [organization, setOrganization] = useState(-2);
  const [companiesLoading, setCompaniesLoading] = useState(false);


  const [CompanyId, setCompanyId] = useState("");
  const [IsTrue, setIsTrue] = useState(false);


  useEffect(() => {
    GetDetailsToAddUser();
  }, []);

  const GetOrganizationsList = async (orgType) => {
    setCompaniesLoading(true);
    const response = await axios.get(
      BaseURL.settings.GetOrganizationsList + "?userType=" + orgType
    );

    if (response.data?.data) {
      setOrganization(-2);

      if (getOrgType() != "Admin") {
        setCompanyId(response.data.data[0]?.value);
      }

      setOrganizations(
        response.data.data?.map((r) => ({
          value: r.value,
          text: r.text,
          selected: r.selected,
        }))
      );
      setCompaniesLoading(false);
    }
  };

  const GetDetailsToAddUser = async () => {
    const response = await axios.get(BaseURL.settings.GetDetailsToAddUser);

    if (response.data?.data) {
      // console.log(response.data?.data?.orgTypes);
      setOrgTypes(
        response.data.data?.orgTypes?.map((r) => ({
          value: r.value,
          text: r.text,
          selected: r.selected,
        }))
      );

      if (getOrgType() != "Admin") {
        const Id = response.data.data?.orgTypes[1]?.value
        handleOrgTypeChange(Number(Id))
      }
      //setOrganizations(response.data.data?.organizations?.map(r => ({ value: r.value, text: r.text, selected: r.selected })))
    }
  };
  const [error, setError] = React.useState(null);

  // const [selectedValue, setSelectedValue] = React.useState('');
  // const [selectedValue1, setSelectedValue2] = React.useState('');

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-])|(\\([0-9]{2,3}\\)[ \\-])|([0-9]{2,4})[ \\-])?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required !")
      .email("Invalid Email !")
      .matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,20}$/, "Invalid email!"),
    // .test("email-dot-validation", "Invalid email!", (value) => {
    //   if (value && value.includes(".")) {
    //     const dotIndex = value.lastIndexOf(".");
    //     // Check if there are more than 20 characters after the dot
    //     if (value.length - dotIndex > 21) {
    //       return false;
    //     }
    //   }
    //   return true;
    // }),
    OrganizationType: getOrgType() == "Client" ? Yup.string() : Yup.number()
      .required("Organization Type is required!")
      .min(0, "Select a valid Organization Type"),
    Company: Yup.number()
      //   .required("Organization is required!")
      .test("isValidOrganization", "Invalid organization", function (value) {
        return getOrgType() == "Admin" ? organization > -2 : CompanyId;
        // return organizations.some((item) => item.text === value);
      })

      .min(-1, "Select a valid Organization"),
    Password: Yup.string().required("Password is required!"),
    ConfirmPassword: Yup.string()
      .required("Confirm Password is required!")
      .oneOf([Yup.ref("Password"), null], "Passwords must match!"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema) });

  const handleOrgTypeChange = (r) => {
    setOrgType(r);
    setOrganization("-2");
    if (r != -1) GetOrganizationsList(r);
  };
  const handleChange1 = (selectedValue) => {
    setOrganization(selectedValue);
  };

  const Cancel = () => {
    props.close(true);
  };

  const onSubmit = async (data) => {
    setError(null);
    setIsTrue(true);
    let userData = {
      organizationId: getOrgType() == "Admin" ? organization : CompanyId,
      email: data.email,
      password: data.Password,
      confirmPassword: data.ConfirmPassword,
    };

    const response = await axios.post(
      BaseURL.baseUrl + BaseURL.settings.AddNewUser,
      userData
    );
    if (response.data?.responseCode >= 0) {
      if (response.data?.data?.userId) {
        toastNotify("Success", true);
        const userId = encodeURIComponent(response.data?.data?.userId);
        navigate("/UserDetails?u=" + userId);
      }
      setIsTrue(false);
    } else if (response.data?.responseCode == -100) {
      toastNotify(response.data?.responseMessage, false);
      setIsTrue(false);
    } else if (response.data?.responseCode == -200) {
      const errorMessages = Object.entries(response.data.error).map(
        ([fieldName, messages]) => {
          return `${fieldName}: ${messages.join(", ")}`;
        }
      );
      setIsTrue(false);
      toastNotify(errorMessages.join(" | "), false);
    } else {
      toastNotify(response.data);
      setIsTrue(false);
    }
  };
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <ToastContainer />
      <DialogContent
        sx={{ padding: "40px 48px", overflowX: "hidden" }}
        className="pb-1"
      > <span className='mx-2' onClick={Cancel} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 500,
            fontSize: 20,
          }}
        >
          Add User
        </DialogTitle>
        <a
          hidden={getOrgType() != "Admin"}
          className="username-label mx-2 mb-4"
          onClick={handleClickOpen}
          style={{
            color: "#2A93DB",
            textAlign: "center",
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          <Upperarrow /> Upload Users
        </a>
        <Dialog
          maxWidth={"sm"}
          fullWidth={true}
          open={open}
          onClose={handleClose}
        >
          <UploadUser close={handleClose} />
        </Dialog>
        <div hidden={getOrgType() != "Admin"}>
          <span className="username-label mx-2 mt-1" style={{ color: "#3E4A62" }}>
            User Organization Type <span className="red-color">*</span>
          </span>
          <Select
            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
            value={orgType}
            required
            size="small"
            placeholder="Organization Type"
            name="Organizationtype"
            id="Organizationtype"
            className="form-control text-feild-custom mx-2"
            {...register("OrganizationType")}
            onChange={(e) => handleOrgTypeChange(e?.target?.value)}
          >
            {orgTypes?.map((r, index) => (
              <MenuItem key={index} value={r.value}>
                {r.text}
              </MenuItem>
            ))}
          </Select>
          <Typography className="text-danger mx-2 mt-1">
            {errors.OrganizationType?.message}
          </Typography>
        </div>


        {getOrgType() == "Admin" ?
          <div>
            <span style={{ color: "#3E4A62" }} className="username-label mx-2 mt-2">
              Company <span className="red-color">*</span>
            </span>
            <AutoCompleteVariableSize
              options={organizations}
              isLoading={companiesLoading}
              selectedOption={organization}
              name="Company"
              defaultOption={{ text: "Select Organization", value: -2 }}
              handleChange={handleChange1}
            />
            {/* <VariableSizeSelect
              options={organizations}
              isLoading={companiesLoading}
              handleChange={handleChange1}
              defaultValue={organization}
              name="Company"
              defaultValueObj={{text:"Select Organization", value:-2}}
              /> */}
            <Typography className="text-danger mx-2 mt-1">
              {errors.Company?.message}
            </Typography>
          </div>
          :
          <div>
            <span style={{ color: "#3E4A62" }} className="username-label mx-2 mt-2">
              Company <span className="red-color">*</span>
            </span>
            <Select
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              value={CompanyId}
              required
              size="small"
              placeholder="Company"
              name="Company"
              id="Company"
              className="form-control text-feild-custom mx-2"
              onChange={(e) => setCompanyId(e?.target?.value)}
            >
              {organizations?.map((r, index) => (
                <MenuItem key={index} value={r.value}>
                  {r.text}
                </MenuItem>
              ))}
            </Select>
            <Typography className="text-danger mx-2 mt-1">
              {errors.OrganizationType?.message}
            </Typography>
          </div>

        }

        <span style={{ color: "#3E4A62" }} className="username-label mx-2 mt-2">
          Email Address <span className="red-color">*</span>
        </span>
        <TextField
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
          }}
          required
          type="text"
          id="email"
          name="email"
          placeholder="Email"
          size="small"
          className="form-control text-feild-custom mx-2"
          {...register("email")}
        />
        <Typography className="text-danger mx-2 mt-1">
          {errors.email?.message}
        </Typography>

        <span style={{ color: "#3E4A62" }} className="username-label mx-2 mt-2">
          Password <span className="red-color">*</span>
        </span>
        <TextField
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
          }}
          required
          type="password"
          id="Password"
          name="Password"
          placeholder="Password"
          size="small"
          className="form-control text-feild-custom mx-2"
          {...register("Password")}
        />
        <Typography className="text-danger mx-2 mt-1">
          {errors.Password?.message}
        </Typography>

        <span style={{ color: "#3E4A62" }} className="username-label mx-2 mt-2">
          Confirm Password <span className="red-color">*</span>
        </span>
        <TextField
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
          }}
          required
          type="password"
          id="ConfirmPassword"
          name="ConfirmPassword"
          placeholder="Confirm Password"
          size="small"
          className="form-control text-feild-custom mx-2"
          {...register("ConfirmPassword")}
        />
        <Typography className="text-danger mx-2 mt-1">
          {errors.ConfirmPassword?.message}
        </Typography>
        {error && (
          <Typography mt={2} className="text-danger mx-3 mt-1">
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions className="pb-5">
        <div className="login-help__buttonContainer d-flex gap-2 align-items-center px-5">
          <Button
            variant="contained"
            className="login-help-button-cancel mx-2"
            onClick={Cancel}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="login-button-request mx-2"
            onClick={handleSubmit(onSubmit)}
            disabled={IsTrue}
          >
            Next
          </Button>
        </div>
      </DialogActions>
      {/* {error && <div className="mt-1" style={{ color: "red", textAlign: "center" }}>{error}</div>} */}
    </>
  );
}
